// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ingredient {
  border: 2px ridge grey;
  border-radius: 5px;
  display: flex;
  padding: 5px 5px 5px 5px;
}
`, "",{"version":3,"sources":["webpack://./src/recipe-component/ingredient.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B","sourcesContent":[".ingredient {\n  border: 2px ridge grey;\n  border-radius: 5px;\n  display: flex;\n  padding: 5px 5px 5px 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
